import { z } from 'zod';

export const HistoryMessageSchema = z.object({
  id: z.string().min(1),
  role: z.enum(['user', 'assistant']),
  content: z.string(),
  incomplete: z.boolean(),
  createdAt: z.iso.datetime(),
});

export type HistoryMessage = z.infer<typeof HistoryMessageSchema>;

export const ServerFrameSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('ready'),
    conversationId: z.string().min(1),
    history: z.array(HistoryMessageSchema),
  }),
  z.object({
    type: z.literal('delta'),
    clientMessageId: z.string().min(1),
    token: z.string(),
  }),
  z.object({
    type: z.literal('done'),
    clientMessageId: z.string().min(1),
    messageId: z.string().min(1),
    tokensInput: z.number(),
    tokensOutput: z.number(),
    cachedReadTokens: z.number(),
  }),
  z.object({
    type: z.literal('cancelled'),
    clientMessageId: z.string().min(1),
    messageId: z.string().min(1),
  }),
  z.object({
    type: z.literal('error'),
    code: z.string(),
    message: z.string(),
    clientMessageId: z.string().min(1).optional(),
  }),
  z.object({ type: z.literal('unauthorized') }),
  z.object({ type: z.literal('pong') }),
]);

export type ServerFrame = z.infer<typeof ServerFrameSchema>;

/** UI-level message — bubble in the rail. */
export interface AssistantMessage extends HistoryMessage {
  /** True while deltas are still streaming into this bubble. */
  streaming?: boolean;
  /** Only on the assistant bubble — set to the user's send id so deltas
   *  can find it. Cleared after `done`. */
  clientMessageId?: string;
}

export type AssistantStatus =
  | 'idle'
  | 'connecting'
  | 'ready'
  | 'asking'
  | 'reconnecting'
  | 'unauthorized';
